/* Raw Organics - custom.js
   Gemmer scroll-position + sidehoejde for kollektionssider (pr. URL, sessionStorage).
   Selve gendannelsen ved tilbage-navigation sker i inline-scriptet i snippets/head.liquid. */
(function () {
  try {
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    var key = 'ro-scroll:' + location.pathname + location.search;
    var timer = null;
    var lastY = 0;

    var save = function (fromPagehide) {
      try {
        var y = Math.round(window.pageYOffset || window.scrollY || 0);
        var h = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
        if (y === 0) {
          /* iOS nulstiller scroll under sidens nedlukning - stol aldrig paa pludselige 0'er */
          if (fromPagehide) return;
          if (document.visibilityState === 'hidden') return;
          if (lastY > 800) return;
        }
        lastY = y;
        sessionStorage.setItem(key, JSON.stringify({ y: y, h: h }));
      } catch (e) {}
    };

    window.addEventListener('scroll', function () {
      if (window.__roRestoring) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { save(false); }, 150);
    }, { passive: true });

    /* sidste ord inden man forlader siden - men kun hvis laesningen er trovaerdig */
    window.addEventListener('pagehide', function () {
      save(true);
    });
  } catch (e) { /* maa aldrig paavirke resten af siden */ }
})();
